export const relevanceConfig = {
  type: 'categorical', // 'numeric' | 'categorical'
  numeric: {
    min: 0,
    max: 10,
    step: 0.5,
  },
  categorical: {
    levels: [
      { value: 'low', labelKey: 'labels.relevanceLevels.low' },
      { value: 'medium', labelKey: 'labels.relevanceLevels.medium' },
      { value: 'high', labelKey: 'labels.relevanceLevels.high' },
    ],
  },
}

export function isCategoricalRelevance() {
  return relevanceConfig.type === 'categorical'
}

export function isNumericRelevance() {
  return relevanceConfig.type === 'numeric'
}

export function toNumericRelevance(value) {
  if (value === null || value === undefined || value === '') return null
  const numeric = Number(value)
  return Number.isFinite(numeric) ? numeric : null
}

export function normalizeCategoricalRelevance(value) {
  if (value === null || value === undefined) return null
  return String(value).trim().toLowerCase()
}

export function getCategoricalLevels() {
  return relevanceConfig.categorical?.levels ?? []
}

export function getCategoricalIndex(value) {
  const normalized = normalizeCategoricalRelevance(value)
  if (!normalized) return -1

  return getCategoricalLevels().findIndex((level) => level.value === normalized)
}

export function getCategoricalValueByIndex(index) {
  const level = getCategoricalLevels()[index]
  return level ? level.value : null
}

export function getLocalizedRelevanceLabel(value, t) {
  if (!isCategoricalRelevance()) return null

  const normalized = normalizeCategoricalRelevance(value)
  if (!normalized) return null

  const level = getCategoricalLevels().find((item) => item.value === normalized)
  return level ? t(level.labelKey) : value
}

export function isRelevanceInRange(score, minValue, maxValue) {
  if (isNumericRelevance()) {
    const numericScore = toNumericRelevance(score)
    if (numericScore === null) return false

    const numericMin = toNumericRelevance(minValue)
    const numericMax = toNumericRelevance(maxValue)

    if (numericMin !== null && numericScore < numericMin) return false
    if (numericMax !== null && numericScore > numericMax) return false
    return true
  }

  const scoreIndex = getCategoricalIndex(score)
  if (scoreIndex < 0) return false

  const minIndex = minValue === null ? null : getCategoricalIndex(minValue)
  const maxIndex = maxValue === null ? null : getCategoricalIndex(maxValue)

  if (minIndex !== null && minIndex >= 0 && scoreIndex < minIndex) return false
  if (maxIndex !== null && maxIndex >= 0 && scoreIndex > maxIndex) return false

  return true
}
